/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'chevron': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M10.025 6.11l6.364 6.365-1.414 1.414L8.61 7.525z"/><path pid="1" d="M11.39 7.525L5.024 13.89l-1.414-1.414L9.975 6.11z"/></g>'
  }
})
